export const data = {


    scene: '03_sauvat_matala_plusplus',
    kysymysteksti: 'Säädit sauvat ihan liian matalalle = lyhyiksi - kyllä ne sauvat pitää olla oikealle korkeudelle säädetty - kokeile säätää vielä uudelleen.',

    optiot: []


};